import { Component, OnInit } from '@angular/core';
import { faMapMarkerAlt, faPhoneSquareAlt, faClock, faAt, } from '@fortawesome/free-solid-svg-icons';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    standalone: false
})
export class FooterComponent implements OnInit {

  faMapMarkerAlt = faMapMarkerAlt;
  faPhoneSquareAlt = faPhoneSquareAlt;
  faClock = faClock;
  faAt = faAt;

  constructor() { }

  ngOnInit() {
  }

}
